<template>
  <div class="price">
    <Nav></Nav>
    <div class="price-banner flex-center">
      <div class="banner-content flex">
        <h1 class="banner-title">硬核渲酷</h1>
        <h1 class="banner-title">快到起飞</h1>
        <h1 class="banner-title">省到冰点</h1>
      </div>
    </div>
    <div class="price-content">
      <div class="price-box" data-aos="fade-in">
        <div class="price-item flex-center">
            <div class="price">
              <p class="price-class">效果图CPU 低至</p>
              <div class="price-desc">
                <div class="flex-align-end" style="margin-left: -9px;">
                  <div class="price-img">
                    <span class="price-icon mr5">￥</span>
                    <span class="price-text">0.005</span>
                  </div>
                  <p class="price-unit">元/线程时</p>
                </div>
              </div>
            </div>
          </div>
        <!-- <el-row class="price-list">
          <el-col data-aos="fade-right" :xs="24" :sm="24" :md="24" :lg="24" :xl="24"></el-col>
          <el-col data-aos="fade-left" :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
            <div class="price-item price-right">
              <div class="price-datail price-left hidden-xs-only " data-aos="fade-in" >
                <p class="price-title">动画端CPU畅享套餐：单价最低0.5元/机时</p>
                <ul class="price-deac-list">
                  <li>充500送500，核算单价1.25元/机时</li>
                  <li>充1000送800，核算单价0.83元/机时</li>
                  <li>充5000送10000，核算单价0.5元/机时</li>
                </ul>
              </div>
            </div>
          </el-col>
          <div class="shu hidden-xs-only"></div>
        </el-row> -->
      </div>
      <el-row class="container price-details" type="flex" justify="center" data-aos="fade-up">
        <!-- <el-col class="price-details-item" :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
          <div class="price-details-item-top">
            <span class="price-item-title">40</span>
            <span class="price-item-desc">线程 / 20核心</span>
          </div>
          <div class="price-details-item-bottom">
            <span class="price-item-desc" title="实际结算价格以渲酷系统计算为准">低至 ￥</span>
            <span class="price-item-low">0.88</span>
            <span class="price-item-desc">元/机时</span>
          </div>
        </el-col> -->
        <el-col class="price-details-item" :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <div class="price-details-item-top">
            <span class="price-item-title">56</span>
            <span class="price-item-desc">线程 / 28核心</span>
          </div>
          <div class="price-details-item-bottom">
            <span class="price-item-desc" title="实际结算价格以渲酷系统计算为准"><span class="price-item-del">￥1.28</span> 低至 </span>
            <span class="price-item-low">0.28</span>
            <span class="price-item-desc">元/机时</span>
          </div>
        </el-col>
        <el-col class="price-details-item" :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <div class="price-details-item-top">
            <span class="price-item-title">104</span>
            <span class="price-item-desc">线程 / 52核心</span>
          </div>
          <div class="price-details-item-bottom">
            <span class="price-item-desc" title="实际结算价格以渲酷系统计算为准"><span class="price-item-del"> ￥1.98</span> 低至 </span>
            <span class="price-item-low">0.43</span>
            <span class="price-item-desc">元/机时</span>
          </div>
        </el-col>
      </el-row>
      <p class="price-texts">内存默认64GB，128GB加收20%，256GB加收60%</p>
      <p class="price-animation flex-center">
        动画客户端单价请联系
        <a style="color: #09CCD8;" target="_blank" href="https://work.weixin.qq.com/kfid/kfc3f425c079eec98a7">在线客服</a>
      </p>
    </div>
    <div class="price-explain-box">
        <div class="price-explain container">
        <p class="price-explain-title">价格说明</p>
        <ul class="price-explain-list">
          <li> 计费方式：
            <p class="explain-text">渲染费用=单机渲染价格*N台机器渲染总时长。渲酷未设多机溢价，分块/分布式渲染模式计费单价与单机渲染单价一致。</p>
          </li>
          <li> 计费规则：
            <p class="explain-text">闲时渲染计费规则：</p>
            <p class="explain-text">闲时渲染任务消费由账户余额抵扣，56线机型单价0.28元/机时，104线单价0.43元/机时。</p>
            <p class="explain-text">非闲时渲染计费规则：</p>
            <p class="explain-text">余额≥300元：任务消费金额38%由余额抵扣，62%由代金券抵扣（38折），即 56 线 0.49 元/机时；104 线 0.75 元/机时。</p>
            <p class="explain-text">余额 &lt; 300元：任务消费金额43%由余额抵扣，57%由代金券抵扣（43折），即 56 线 0.55 元/机时；104 线 0.85 元/机时。</p>
            <p class="explain-text">余额 &lt; 18元 ：任务消费金额48% 余额扣除，52% 代金券抵扣（48折），即 56 线 0.61 元/机时；104 线 0.95 元/机时。</p>
            <p class="explain-text">任务渲染时长低于10小时时按照正常计费规则计费：渲染总费用=单价*任务渲染时长；</p>
          </li>
          <li> 封顶价格说明：封顶任务机时阈值为 18 小时，超出部分按单价累计。
            <p class="explain-text">渲染时长处于10-18小时区间：</p>
            <p class="explain-text">闲时渲染：按照封顶价一次性执行：2.8-4.3元；</p>
            <p class="explain-text">非闲时渲染：按照封顶价一次性执行：4.9-7.5元；</p>
            <p class="explain-text">渲染时长超过 18 小时的：</p>
            <p class="explain-text">闲时渲染：按照封顶价一次性执行：2.8-4.3元+超出时间*单价；</p>
            <p class="explain-text">非闲时渲染：按照封顶价一次性执行：4.9-7.5元+超出时间*单价；</p>
          </li>
          <li> 渲酷于每日06:00自动发放代金券，欠费账户不在赠券范围内。补齐欠费后次日仍可参与每日赠券活动。</li>
          <li> 所有价格均不含税，如需收据/发票请联系客服。</li>
        </ul>
      </div>
      <div class="price-explain  container">
        <p class="price-explain-title mt30">渲染异常说明</p>
        <ul class="price-explain-list">
          <li> 为避免恶意占用机器、防止提交大量垃圾文件而过度消耗产能的行为，进而影响其他用户的正常使用，渲酷规定：当账户余额小于 8 元时，将无法提交渲染任务。</li>
          <li> 任务渲染时长超出自设定“渲染超时时间”，渲染任务将停止。插件面板位置可修改超时时间。“渲染超时时间”以分块/分布式渲染任务时间总和为判定。建议您在提交任务时，在插件面板位置设置合适的“渲染超时时间”，“超时时间”设置为0即默认未设超时时间。如系统检测到您的任务渲染时间异常则会第一时间与您取得联系确认，如未联系到您，任务将停止渲染。如您有预估渲染时间较长的任务，请提前联系客服，我们将为您重点监测。</li>
          <li> 渲酷邀请共惠活动仅有唯一参与方式：效果图客户端右上角获取专属邀请链接，该链接进入注册为有效邀请，邀请方将获得系统自动赠券。</li>
          <li> 渲酷有权对恶意注册账户进行任务提取限制，如您的账户属于企业用户，请联系官网客服标记企业信息。</li>
          <li> 账户欠费将无法下载已完成的渲染任务。</li>
        </ul>
      </div>
    </div>
    <!-- 注册按钮 -->
    <section class="flex-center download-now">
      <div class="">
        <p class="download-header">动画端注册就送20元无门槛渲染费</p>
        <a target="_blank" href="https://s.rendercool.com/#/register?flag=register"><div class="download-btn">点击领取</div></a>
      </div>
    </section>
    <!-- 注册按钮结束 -->
    <!-- 关于我们开始 -->
    <section class="aboutus-box" data-aos="fade-in" data-aos-duration="1000" data-aos-easing="ease-in-out">
      <ul>
        <li class="aboutus-item">
          <p class="aboutus-title">CONTACT US</p>
          <div class="flex-align-center flex-center ">
            <p class="flex-align-center aboutus-phone">
              <img class="mr5 aboutus-img " src="../assets/images/icon-phone.png" alt="">
              <span class="about-text">15083301945</span>
            </p>
            <p class="flex-align-center">
              <img class="mr5 aboutus-img" src="../assets/images/icon-qq.png" alt="">
              <span class="about-text">1478887151</span>
            </p>
          </div>
        </li>
        <li class="aboutus-item">
          <p class="aboutus-title">LINK</p>
          <div class="flex-align-center flex-center ">
            <a href="https://www.rendercool.com/" rel="noopener noreferrer" class="about-text">www.rendercool.com</a>
          </div>
        </li>
        <li class="aboutus-item">
          <p class="aboutus-title">ADD</p>
          <div class="flex-align-center flex-center ">
            <p class="about-text">浙江省衢州市龙游县金融中心A幢 15 楼</p>
          </div>
        </li>
      </ul>
      
    </section>
    <!-- 关于我们结束 -->

    <Position></Position>
    <footer class="flex-center footer-box">
      <div class="footer">
        Copyright © {{ year }} {{ localhost }} 备案号：
        <a 
          target="_blank" 
          href="https://beian.miit.gov.cn/#/Integrated/index">
          {{ recordNo }}
        </a>
        <a href="sitemap.htm">网站地图</a>
      </div>
    </footer>
  </div>
</template>

<script>
import Nav from '../components/Nav/index.vue'
import Position from '../components/Position/index.vue'
export default {
  name: "Price",
  components: {
    Nav,
    Position
  },
  data() {
    return {
      year: new Date().getFullYear(),
      localhost: 'www.rendercool.com',
      recordNo: '浙ICP备2021000000号-2'
    }
  },
  created() {
    this.getRecordHost()
  },
  methods: {

    getRecordHost() {

      let str = window.location.href.split('rendercool')[1].split('/')[0]
      console.log('str', str)
      // 根据域名设置对应的备案号
      if (str === '.com') {
        this.localhost = 'www.rendercool.com'
        this.recordNo = '浙ICP备2025207059号-2'
      } else if (str === '.cn') {
        this.localhost = 'www.rendercool.cn'
        this.recordNo = '浙ICP备2025207059号-1'
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import url('../style/price.scss');
</style>
